// --------------------------
// 輸入地址自動填入郵遞區號 簡易版
// 資料來源：https://github.com/essoduke/jQuery-TWzipcode
//
// author: Wayne
// createtime: 2016/08/18
// updatetime: 2017/09/13 by Gray
// --------------------------
window.InifECMobileApp.directive('twZipCode', ['$parse', '$rootScope', '$compile', '$timeout',  function($parse, $rootScope, $compile, $timeout ) {

    var _dir = {};

    var controller = ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
        
        // 欄位說明：
        // otherShippingFee 為加收運費 (如偏遠地區), largeShippingFee 為大型商品專車運送費用, unknownLargeShippingFee 為 不知道費用，要改為後報價
        // 若是一般商品，則是原先運費 88 再加上 otherShippingFee, 若是大型商品，則只以 largeShippingFee 來計算

        var zipcodedata = {
            '基隆市': {
                '仁愛區': { name: '仁愛區', zipcode: '200', otherShippingFee: 0, largeShippingFee: 1100 },
                '信義區': { name: '信義區', zipcode: '201', otherShippingFee: 0, largeShippingFee: 1000 },
                '中正區': { name: '中正區', zipcode: '202', otherShippingFee: 0, largeShippingFee: 1000 },
                '中山區': { name: '中山區', zipcode: '203', otherShippingFee: 0, largeShippingFee: 1000 },
                '安樂區': { name: '安樂區', zipcode: '204', otherShippingFee: 0, largeShippingFee: 1000 },
                '暖暖區': { name: '暖暖區', zipcode: '205', otherShippingFee: 0, largeShippingFee: 1000 },
                '七堵區': { name: '七堵區', zipcode: '206', otherShippingFee: 0, largeShippingFee: 1000 },
            },
            '臺北市': {
                '中正區': { name: '中正區', zipcode: '100', otherShippingFee: 0, largeShippingFee: 600 },
                '大同區': { name: '大同區', zipcode: '103', otherShippingFee: 0, largeShippingFee: 600 },
                '中山區': { name: '中山區', zipcode: '104', otherShippingFee: 0, largeShippingFee: 600 },
                '松山區': { name: '松山區', zipcode: '105', otherShippingFee: 0, largeShippingFee: 600 },
                '大安區': { name: '大安區', zipcode: '106', otherShippingFee: 0, largeShippingFee: 600 },
                '萬華區': { name: '萬華區', zipcode: '108', otherShippingFee: 0, largeShippingFee: 600 },
                '信義區': { name: '信義區', zipcode: '110', otherShippingFee: 0, largeShippingFee: 600 },
                '士林區': { name: '士林區', zipcode: '111', otherShippingFee: 0, largeShippingFee: 600 },
                '北投區': { name: '北投區', zipcode: '112', otherShippingFee: 0, largeShippingFee: 700 },
                '內湖區': { name: '內湖區', zipcode: '114', otherShippingFee: 0, largeShippingFee: 700 },
                '南港區': { name: '南港區', zipcode: '115', otherShippingFee: 0, largeShippingFee: 700 },
                '文山區': { name: '文山區', zipcode: '116', otherShippingFee: 0, largeShippingFee: 700 },
            },
            '新北市': {
                '萬里區': { name: '萬里區', zipcode: '207', otherShippingFee: 75, largeShippingFee: 1100 },
                '金山區': { name: '金山區', zipcode: '208', otherShippingFee: 75, largeShippingFee: 1300 },
                '板橋區': { name: '板橋區', zipcode: '220', otherShippingFee: 0, largeShippingFee: 400 },
                '汐止區': { name: '汐止區', zipcode: '221', otherShippingFee: 0, largeShippingFee: 700 },
                '深坑區': { name: '深坑區', zipcode: '222', otherShippingFee: 0, largeShippingFee: 700 },
                '石碇區': { name: '石碇區', zipcode: '223', otherShippingFee: 0, largeShippingFee: 1000 },
                '瑞芳區': { name: '瑞芳區', zipcode: '224', otherShippingFee: 110, largeShippingFee: 1000 },
                '平溪區': { name: '平溪區', zipcode: '226', otherShippingFee: 110, largeShippingFee: 1200 },
                '雙溪區': { name: '雙溪區', zipcode: '227', otherShippingFee: 110, largeShippingFee: 1200 },
                '貢寮區': { name: '貢寮區', zipcode: '228', otherShippingFee: 110, largeShippingFee: 1500 },
                '新店區': { name: '新店區', zipcode: '231', otherShippingFee: 0, largeShippingFee: 500 },
                '坪林區': { name: '坪林區', zipcode: '232', otherShippingFee: 0, largeShippingFee: 1500 },
                '烏來區': { name: '烏來區', zipcode: '233', otherShippingFee: 0, largeShippingFee: 1200 },
                '永和區': { name: '永和區', zipcode: '234', otherShippingFee: 0, largeShippingFee: 500 },
                '中和區': { name: '中和區', zipcode: '235', otherShippingFee: 0, largeShippingFee: 400 },
                '土城區': { name: '土城區', zipcode: '236', otherShippingFee: 0, largeShippingFee: 450 },
                '三峽區': { name: '三峽區', zipcode: '237', otherShippingFee: 0, largeShippingFee: 900 },
                '樹林區': { name: '樹林區', zipcode: '238', otherShippingFee: 0, largeShippingFee: 600 },
                '鶯歌區': { name: '鶯歌區', zipcode: '239', otherShippingFee: 0, largeShippingFee: 1000 },
                '三重區': { name: '三重區', zipcode: '241', otherShippingFee: 0, largeShippingFee: 600 },
                '新莊區': { name: '新莊區', zipcode: '242', otherShippingFee: 0, largeShippingFee: 1000 },
                '泰山區': { name: '泰山區', zipcode: '243', otherShippingFee: 0, largeShippingFee: 700 },
                '林口區': { name: '林口區', zipcode: '244', otherShippingFee: 0, largeShippingFee: 1000 },
                '蘆洲區': { name: '蘆洲區', zipcode: '247', otherShippingFee: 0, largeShippingFee: 700 },
                '五股區': { name: '五股區', zipcode: '248', otherShippingFee: 0, largeShippingFee: 600 },
                '八里區': { name: '八里區', zipcode: '249', otherShippingFee: 0, largeShippingFee: 900 },
                '淡水區': { name: '淡水區', zipcode: '251', otherShippingFee: 0, largeShippingFee: 900 },
                '三芝區': { name: '三芝區', zipcode: '252', otherShippingFee: 0, largeShippingFee: 1200 },
                '石門區': { name: '石門區', zipcode: '253', otherShippingFee: 0, largeShippingFee: 1200 },
            },
            '宜蘭縣': {
                '宜蘭市': { name: '宜蘭市', zipcode: '260', otherShippingFee: 0, largeShippingFee: 2200 },
                '頭城鎮': { name: '頭城鎮', zipcode: '261', otherShippingFee: 0, largeShippingFee: 2000 },
                '礁溪鄉': { name: '礁溪鄉', zipcode: '262', otherShippingFee: 0, largeShippingFee: 2000 },
                '壯圍鄉': { name: '壯圍鄉', zipcode: '263', otherShippingFee: 0, largeShippingFee: 2200 },
                '員山鄉': { name: '員山鄉', zipcode: '264', otherShippingFee: 0, largeShippingFee: 2200 },
                '羅東鎮': { name: '羅東鎮', zipcode: '265', otherShippingFee: 0, largeShippingFee: 2400 },
                '三星鄉': { name: '三星鄉', zipcode: '266', otherShippingFee: 0, largeShippingFee: 2600 },
                '大同鄉': { name: '大同鄉', zipcode: '267', otherShippingFee: 0, largeShippingFee: 2600 },
                '五結鄉': { name: '五結鄉', zipcode: '268', otherShippingFee: 0, largeShippingFee: 2500 },
                '冬山鄉': { name: '冬山鄉', zipcode: '269', otherShippingFee: 0, largeShippingFee: 2500 },
                '蘇澳鎮': { name: '蘇澳鎮', zipcode: '270', otherShippingFee: 75, largeShippingFee: 3000 },
                '南澳鄉': { name: '南澳鄉', zipcode: '272', otherShippingFee: 160, largeShippingFee: 3500 },
                '釣魚臺列嶼': { name: '釣魚臺列嶼', zipcode: '290', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '新竹市': {
                '東區': { name: '東區', zipcode: '300', otherShippingFee: 0, largeShippingFee: 2000 },
                '北區': { name: '北區', zipcode: '300', otherShippingFee: 0, largeShippingFee: 2000 },
                '香山區': { name: '香山區', zipcode: '300', otherShippingFee: 0, largeShippingFee: 2000 },
            },
            '新竹縣': {
                '竹北市': { name: '竹北市', zipcode: '302', otherShippingFee: 0, largeShippingFee: 1800 },
                '湖口鄉': { name: '湖口鄉', zipcode: '303', otherShippingFee: 0, largeShippingFee: 1700 },
                '新豐鄉': { name: '新豐鄉', zipcode: '304', otherShippingFee: 0, largeShippingFee: 1800 },
                '新埔鎮': { name: '新埔鎮', zipcode: '305', otherShippingFee: 0, largeShippingFee: 2000 },
                '關西鎮': { name: '關西鎮', zipcode: '306', otherShippingFee: 0, largeShippingFee: 2000 },
                '芎林鄉': { name: '芎林鄉', zipcode: '307', otherShippingFee: 0, largeShippingFee: 2000 },
                '寶山鄉': { name: '寶山鄉', zipcode: '308', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '竹東鎮': { name: '竹東鎮', zipcode: '310', otherShippingFee: 0, largeShippingFee: 2000 },
                '五峰鄉': { name: '五峰鄉', zipcode: '311', otherShippingFee: 150, largeShippingFee: 0, unknownLargeShippingFee: true },
                '橫山鄉': { name: '橫山鄉', zipcode: '312', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '尖石鄉': { name: '尖石鄉', zipcode: '313', otherShippingFee: 150, largeShippingFee: 0, unknownLargeShippingFee: true },
                '北埔鄉': { name: '北埔鄉', zipcode: '314', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '峨嵋鄉': { name: '峨嵋鄉', zipcode: '315', otherShippingFee: 90, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '桃園市': {
                '中壢區': { name: '中壢區', zipcode: '320', otherShippingFee: 0, largeShippingFee: 1200 },
                '平鎮區': { name: '平鎮區', zipcode: '324', otherShippingFee: 0, largeShippingFee: 1100 },
                '龍潭區': { name: '龍潭區', zipcode: '325', otherShippingFee: 0, largeShippingFee: 1300 },
                '楊梅區': { name: '楊梅區', zipcode: '326', otherShippingFee: 0, largeShippingFee: 1400 },
                '新屋區': { name: '新屋區', zipcode: '327', otherShippingFee: 0, largeShippingFee: 1200 },
                '觀音區': { name: '觀音區', zipcode: '328', otherShippingFee: 0, largeShippingFee: 1200 },
                '桃園區': { name: '桃園區', zipcode: '330', otherShippingFee: 0, largeShippingFee: 1000 },
                '龜山區': { name: '龜山區', zipcode: '333', otherShippingFee: 0, largeShippingFee: 1000 },
                '八德區': { name: '八德區', zipcode: '334', otherShippingFee: 0, largeShippingFee: 1100 },
                '大溪區': { name: '大溪區', zipcode: '335', otherShippingFee: 0, largeShippingFee: 1100 },
                '復興區': { name: '復興區', zipcode: '336', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大園區': { name: '大園區', zipcode: '337', otherShippingFee: 0, largeShippingFee: 1100 },
                '蘆竹區': { name: '蘆竹區', zipcode: '338', otherShippingFee: 0, largeShippingFee: 1100 },
            },
            '苗栗縣': {
                '竹南鎮': { name: '竹南鎮', zipcode: '350', otherShippingFee: 0, largeShippingFee: 2600 },
                '頭份市': { name: '頭份市', zipcode: '351', otherShippingFee: 0, largeShippingFee: 2500 },
                '三灣鄉': { name: '三灣鄉', zipcode: '352', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '南庄鄉': { name: '南庄鄉', zipcode: '353', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '獅潭鄉': { name: '獅潭鄉', zipcode: '354', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '後龍鎮': { name: '後龍鎮', zipcode: '356', otherShippingFee: 0, largeShippingFee: 2800 },
                '通霄鎮': { name: '通霄鎮', zipcode: '357', otherShippingFee: 0, largeShippingFee: 3300 },
                '苑裡鎮': { name: '苑裡鎮', zipcode: '358', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '苗栗市': { name: '苗栗市', zipcode: '360', otherShippingFee: 0, largeShippingFee: 2800 },
                '造橋鄉': { name: '造橋鄉', zipcode: '361', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '頭屋鄉': { name: '頭屋鄉', zipcode: '362', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '公館鄉': { name: '公館鄉', zipcode: '363', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大湖鄉': { name: '大湖鄉', zipcode: '364', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '泰安鄉': { name: '泰安鄉', zipcode: '365', otherShippingFee: 380, largeShippingFee: 0, unknownLargeShippingFee: true },
                '銅鑼鄉': { name: '銅鑼鄉', zipcode: '366', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '三義鄉': { name: '三義鄉', zipcode: '367', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '西湖鄉': { name: '西湖鄉', zipcode: '368', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '卓蘭鎮': { name: '卓蘭鎮', zipcode: '369', otherShippingFee: 45, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '臺中市': {
                '中區': { name: '中區', zipcode: '400', otherShippingFee: 0, largeShippingFee: 3900 },
                '東區': { name: '東區', zipcode: '401', otherShippingFee: 0, largeShippingFee: 3900 },
                '南區': { name: '南區', zipcode: '402', otherShippingFee: 0, largeShippingFee: 3900 },
                '西區': { name: '西區', zipcode: '403', otherShippingFee: 0, largeShippingFee: 3900 },
                '北區': { name: '北區', zipcode: '404', otherShippingFee: 0, largeShippingFee: 3900 },
                '北屯區': { name: '北屯區', zipcode: '406', otherShippingFee: 0, largeShippingFee: 3900 },
                '西屯區': { name: '西屯區', zipcode: '407', otherShippingFee: 0, largeShippingFee: 3900 },
                '南屯區': { name: '南屯區', zipcode: '408', otherShippingFee: 0, largeShippingFee: 3900 },
                '太平區': { name: '太平區', zipcode: '411', otherShippingFee: 0, largeShippingFee: 4000 },
                '大里區': { name: '大里區', zipcode: '412', otherShippingFee: 0, largeShippingFee: 4000 },
                '霧峰區': { name: '霧峰區', zipcode: '413', otherShippingFee: 0, largeShippingFee: 4000 },
                '烏日區': { name: '烏日區', zipcode: '414', otherShippingFee: 0, largeShippingFee: 4000 },
                '豐原區': { name: '豐原區', zipcode: '420', otherShippingFee: 0, largeShippingFee: 3700 },
                '后里區': { name: '后里區', zipcode: '421', otherShippingFee: 0, largeShippingFee: 3800 },
                '石岡區': { name: '石岡區', zipcode: '422', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '東勢區': { name: '東勢區', zipcode: '423', otherShippingFee: 130, largeShippingFee: 0, unknownLargeShippingFee: true },
                '和平區': { name: '和平區', zipcode: '424', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '新社區': { name: '新社區', zipcode: '426', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '潭子區': { name: '潭子區', zipcode: '427', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大雅區': { name: '大雅區', zipcode: '428', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '神岡區': { name: '神岡區', zipcode: '429', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大肚區': { name: '大肚區', zipcode: '432', otherShippingFee: 0, largeShippingFee: 4200 },
                '沙鹿區': { name: '沙鹿區', zipcode: '433', otherShippingFee: 0, largeShippingFee: 4000 },
                '龍井區': { name: '龍井區', zipcode: '434', otherShippingFee: 0, largeShippingFee: 3900 },
                '梧棲區': { name: '梧棲區', zipcode: '435', otherShippingFee: 0, largeShippingFee: 3900 },
                '清水區': { name: '清水區', zipcode: '436', otherShippingFee: 0, largeShippingFee: 3900 },
                '大甲區': { name: '大甲區', zipcode: '437', otherShippingFee: 0, largeShippingFee: 3500 },
                '外埔區': { name: '外埔區', zipcode: '438', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大安區': { name: '大安區', zipcode: '439', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '彰化縣': {
                '彰化市': { name: '彰化市', zipcode: '500', otherShippingFee: 0, largeShippingFee: 4500 },
                '芬園鄉': { name: '芬園鄉', zipcode: '502', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '花壇鄉': { name: '花壇鄉', zipcode: '503', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '秀水鄉': { name: '秀水鄉', zipcode: '504', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鹿港鎮': { name: '鹿港鎮', zipcode: '505', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '福興鄉': { name: '福興鄉', zipcode: '506', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '線西鄉': { name: '線西鄉', zipcode: '507', otherShippingFee: 0, largeShippingFee: 3900 },
                '和美鎮': { name: '和美鎮', zipcode: '508', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '伸港鄉': { name: '伸港鄉', zipcode: '509', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '員林市': { name: '員林市', zipcode: '510', otherShippingFee: 0, largeShippingFee: 4800 },
                '社頭鄉': { name: '社頭鄉', zipcode: '511', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '永靖鄉': { name: '永靖鄉', zipcode: '512', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '埔心鄉': { name: '埔心鄉', zipcode: '513', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '溪湖鎮': { name: '溪湖鎮', zipcode: '514', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大村鄉': { name: '大村鄉', zipcode: '515', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '埔鹽鄉': { name: '埔鹽鄉', zipcode: '516', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '田中鎮': { name: '田中鎮', zipcode: '520', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '北斗鎮': { name: '北斗鎮', zipcode: '521', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '田尾鄉': { name: '田尾鄉', zipcode: '522', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '埤頭鄉': { name: '埤頭鄉', zipcode: '523', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '溪州鄉': { name: '溪州鄉', zipcode: '524', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '竹塘鄉': { name: '竹塘鄉', zipcode: '525', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '二林鎮': { name: '二林鎮', zipcode: '526', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大城鄉': { name: '大城鄉', zipcode: '527', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '芳苑鄉': { name: '芳苑鄉', zipcode: '528', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '二水鄉': { name: '二水鄉', zipcode: '530', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '南投縣': {
                '南投市': { name: '南投市', zipcode: '540', otherShippingFee: 0, largeShippingFee: 4500 },
                '中寮鄉': { name: '中寮鄉', zipcode: '541', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '草屯鎮': { name: '草屯鎮', zipcode: '542', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '國姓鄉': { name: '國姓鄉', zipcode: '544', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '埔里鎮': { name: '埔里鎮', zipcode: '545', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '仁愛鄉': { name: '仁愛鄉', zipcode: '546', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '名間鄉': { name: '名間鄉', zipcode: '551', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '集集鎮': { name: '集集鎮', zipcode: '552', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '水里鄉': { name: '水里鄉', zipcode: '553', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '魚池鄉': { name: '魚池鄉', zipcode: '555', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '信義鄉': { name: '信義鄉', zipcode: '556', otherShippingFee: 115, largeShippingFee: 0, unknownLargeShippingFee: true },
                '竹山鎮': { name: '竹山鎮', zipcode: '557', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鹿谷鄉': { name: '鹿谷鄉', zipcode: '558', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '嘉義市': {
                '東區': { name: '東區', zipcode: '600', otherShippingFee: 0, largeShippingFee: 6000 },
                '西區': { name: '西區', zipcode: '600', otherShippingFee: 0, largeShippingFee: 6000 },
            },
            '嘉義縣': {
                '番路鄉': { name: '番路鄉', zipcode: '602', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '梅山鄉': { name: '梅山鄉', zipcode: '603', otherShippingFee: 540, largeShippingFee: 0, unknownLargeShippingFee: true },
                '竹崎鄉': { name: '竹崎鄉', zipcode: '604', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '阿里山': { name: '阿里山', zipcode: '605', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '中埔鄉': { name: '中埔鄉', zipcode: '606', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大埔鄉': { name: '大埔鄉', zipcode: '607', otherShippingFee: 75, largeShippingFee: 0, unknownLargeShippingFee: true },
                '水上鄉': { name: '水上鄉', zipcode: '608', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鹿草鄉': { name: '鹿草鄉', zipcode: '611', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '太保市': { name: '太保市', zipcode: '612', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '朴子市': { name: '朴子市', zipcode: '613', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '東石鄉': { name: '東石鄉', zipcode: '614', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '六腳鄉': { name: '六腳鄉', zipcode: '615', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '新港鄉': { name: '新港鄉', zipcode: '616', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '民雄鄉': { name: '民雄鄉', zipcode: '621', otherShippingFee: 0, largeShippingFee: 5800 },
                '大林鎮': { name: '大林鎮', zipcode: '622', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '溪口鄉': { name: '溪口鄉', zipcode: '623', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '義竹鄉': { name: '義竹鄉', zipcode: '624', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '布袋鎮': { name: '布袋鎮', zipcode: '625', otherShippingFee: 45, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '雲林縣': {
                '斗南鎮': { name: '斗南鎮', zipcode: '630', otherShippingFee: 0, largeShippingFee: 5400 },
                '大埤鄉': { name: '大埤鄉', zipcode: '631', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '虎尾鎮': { name: '虎尾鎮', zipcode: '632', otherShippingFee: 0, largeShippingFee: 5500 },
                '土庫鎮': { name: '土庫鎮', zipcode: '633', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '褒忠鄉': { name: '褒忠鄉', zipcode: '634', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '東勢鄉': { name: '東勢鄉', zipcode: '635', otherShippingFee: 45, largeShippingFee: 0, unknownLargeShippingFee: true },
                '臺西鄉': { name: '臺西鄉', zipcode: '636', otherShippingFee: 45, largeShippingFee: 0, unknownLargeShippingFee: true },
                '崙背鄉': { name: '崙背鄉', zipcode: '637', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '麥寮鄉': { name: '麥寮鄉', zipcode: '638', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '斗六市': { name: '斗六市', zipcode: '640', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '林內鄉': { name: '林內鄉', zipcode: '643', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '古坑鄉': { name: '古坑鄉', zipcode: '646', otherShippingFee: 540, largeShippingFee: 0, unknownLargeShippingFee: true },
                '莿桐鄉': { name: '莿桐鄉', zipcode: '647', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '西螺鎮': { name: '西螺鎮', zipcode: '648', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '二崙鄉': { name: '二崙鄉', zipcode: '649', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '北港鎮': { name: '北港鎮', zipcode: '651', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '水林鄉': { name: '水林鄉', zipcode: '652', otherShippingFee: 45, largeShippingFee: 0, unknownLargeShippingFee: true },
                '口湖鄉': { name: '口湖鄉', zipcode: '653', otherShippingFee: 45, largeShippingFee: 0, unknownLargeShippingFee: true },
                '四湖鄉': { name: '四湖鄉', zipcode: '654', otherShippingFee: 45, largeShippingFee: 0, unknownLargeShippingFee: true },
                '元長鄉': { name: '元長鄉', zipcode: '655', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '臺南市': {
                '中西區': { name: '中西區', zipcode: '700', otherShippingFee: 0, largeShippingFee: 7000 },
                '東區': { name: '東區', zipcode: '701', otherShippingFee: 0, largeShippingFee: 7000 },
                '南區': { name: '南區', zipcode: '702', otherShippingFee: 0, largeShippingFee: 7000 },
                '北區': { name: '北區', zipcode: '704', otherShippingFee: 0, largeShippingFee: 7000 },
                '安平區': { name: '安平區', zipcode: '708', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '安南區': { name: '安南區', zipcode: '709', otherShippingFee: 0, largeShippingFee: 7000 },
                '永康區': { name: '永康區', zipcode: '710', otherShippingFee: 0, largeShippingFee: 7000 },
                '歸仁區': { name: '歸仁區', zipcode: '711', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '新化區': { name: '新化區', zipcode: '712', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '左鎮區': { name: '左鎮區', zipcode: '713', otherShippingFee: 85, largeShippingFee: 0, unknownLargeShippingFee: true },
                '玉井區': { name: '玉井區', zipcode: '714', otherShippingFee: 85, largeShippingFee: 0, unknownLargeShippingFee: true },
                '楠西區': { name: '楠西區', zipcode: '715', otherShippingFee: 85, largeShippingFee: 0, unknownLargeShippingFee: true },
                '南化區': { name: '南化區', zipcode: '716', otherShippingFee: 120, largeShippingFee: 0, unknownLargeShippingFee: true },
                '仁德區': { name: '仁德區', zipcode: '717', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '關廟區': { name: '關廟區', zipcode: '718', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '龍崎區': { name: '龍崎區', zipcode: '719', otherShippingFee: 130, largeShippingFee: 0, unknownLargeShippingFee: true },
                '官田區': { name: '官田區', zipcode: '720', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '麻豆區': { name: '麻豆區', zipcode: '721', otherShippingFee: 0, largeShippingFee: 6400 },
                '佳里區': { name: '佳里區', zipcode: '722', otherShippingFee: 0, largeShippingFee: 6400 },
                '西港區': { name: '西港區', zipcode: '723', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '七股區': { name: '七股區', zipcode: '724', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '將軍區': { name: '將軍區', zipcode: '725', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '學甲區': { name: '學甲區', zipcode: '726', otherShippingFee: 0, largeShippingFee: 6200 },
                '北門區': { name: '北門區', zipcode: '727', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '新營區': { name: '新營區', zipcode: '730', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '後壁區': { name: '後壁區', zipcode: '731', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '白河區': { name: '白河區', zipcode: '732', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '東山區': { name: '東山區', zipcode: '733', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '六甲區': { name: '六甲區', zipcode: '734', otherShippingFee: 50, largeShippingFee: 0, unknownLargeShippingFee: true },
                '下營區': { name: '下營區', zipcode: '735', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '柳營區': { name: '柳營區', zipcode: '736', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鹽水區': { name: '鹽水區', zipcode: '737', otherShippingFee: 0, largeShippingFee: 6400 },
                '善化區': { name: '善化區', zipcode: '741', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大內區': { name: '大內區', zipcode: '742', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '山上區': { name: '山上區', zipcode: '743', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '新市區': { name: '新市區', zipcode: '744', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '安定區': { name: '安定區', zipcode: '745', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '高雄市': {
                '新興區': { name: '新興區', zipcode: '800', otherShippingFee: 0, largeShippingFee: 7500 },
                '前金區': { name: '前金區', zipcode: '801', otherShippingFee: 0, largeShippingFee: 7500 },
                '苓雅區': { name: '苓雅區', zipcode: '802', otherShippingFee: 0, largeShippingFee: 7500 },
                '鹽埕區': { name: '鹽埕區', zipcode: '803', otherShippingFee: 0, largeShippingFee: 7500 },
                '鼓山區': { name: '鼓山區', zipcode: '804', otherShippingFee: 0, largeShippingFee: 7500 },
                '旗津區': { name: '旗津區', zipcode: '805', otherShippingFee: 0, largeShippingFee: 7500 },
                '前鎮區': { name: '前鎮區', zipcode: '806', otherShippingFee: 0, largeShippingFee: 7500 },
                '三民區': { name: '三民區', zipcode: '807', otherShippingFee: 0, largeShippingFee: 7500 },
                '楠梓區': { name: '楠梓區', zipcode: '811', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '小港區': { name: '小港區', zipcode: '812', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '左營區': { name: '左營區', zipcode: '813', otherShippingFee: 0, largeShippingFee: 7500 },
                '仁武區': { name: '仁武區', zipcode: '814', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大社區': { name: '大社區', zipcode: '815', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '東沙群島': { name: '東沙群島', zipcode: '817', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '南沙群島': { name: '南沙群島', zipcode: '819', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '岡山區': { name: '岡山區', zipcode: '820', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '路竹區': { name: '路竹區', zipcode: '821', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '阿蓮區': { name: '阿蓮區', zipcode: '822', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '田寮區': { name: '田寮區', zipcode: '823', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '燕巢區': { name: '燕巢區', zipcode: '824', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '橋頭區': { name: '橋頭區', zipcode: '825', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '梓官區': { name: '梓官區', zipcode: '826', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '彌陀區': { name: '彌陀區', zipcode: '827', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '永安區': { name: '永安區', zipcode: '828', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '湖內區': { name: '湖內區', zipcode: '829', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鳳山區': { name: '鳳山區', zipcode: '830', otherShippingFee: 0, largeShippingFee: 7500 },
                '大寮區': { name: '大寮區', zipcode: '831', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '林園區': { name: '林園區', zipcode: '832', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鳥松區': { name: '鳥松區', zipcode: '833', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大樹區': { name: '大樹區', zipcode: '840', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '旗山區': { name: '旗山區', zipcode: '842', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '美濃區': { name: '美濃區', zipcode: '843', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '六龜區': { name: '六龜區', zipcode: '844', otherShippingFee: 260, largeShippingFee: 0, unknownLargeShippingFee: true },
                '內門區': { name: '內門區', zipcode: '845', otherShippingFee: 175, largeShippingFee: 0, unknownLargeShippingFee: true },
                '杉林區': { name: '杉林區', zipcode: '846', otherShippingFee: 175, largeShippingFee: 0, unknownLargeShippingFee: true },
                '甲仙區': { name: '甲仙區', zipcode: '847', otherShippingFee: 260, largeShippingFee: 0, unknownLargeShippingFee: true },
                '桃源區': { name: '桃源區', zipcode: '848', otherShippingFee: 260, largeShippingFee: 0, unknownLargeShippingFee: true },
                '那瑪夏區': { name: '那瑪夏區', zipcode: '849', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '茂林區': { name: '茂林區', zipcode: '851', otherShippingFee: 260, largeShippingFee: 0, unknownLargeShippingFee: true },
                '茄萣區': { name: '茄萣區', zipcode: '852', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '屏東縣': {
                '屏東市': { name: '屏東市', zipcode: '900', otherShippingFee: 0, largeShippingFee: 8000 },
                '三地門鄉': { name: '三地門鄉', zipcode: '901', otherShippingFee: 215, largeShippingFee: 8000 },
                '霧臺鄉': { name: '霧臺鄉', zipcode: '902', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
                '瑪家鄉': { name: '瑪家鄉', zipcode: '903', otherShippingFee: 110, largeShippingFee: 0, unknownLargeShippingFee: true },
                '九如鄉': { name: '九如鄉', zipcode: '904', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '里港鄉': { name: '里港鄉', zipcode: '905', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '高樹鄉': { name: '高樹鄉', zipcode: '906', otherShippingFee: 50, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鹽埔鄉': { name: '鹽埔鄉', zipcode: '907', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '長治鄉': { name: '長治鄉', zipcode: '908', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '麟洛鄉': { name: '麟洛鄉', zipcode: '909', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '竹田鄉': { name: '竹田鄉', zipcode: '911', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '內埔鄉': { name: '內埔鄉', zipcode: '912', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '萬丹鄉': { name: '萬丹鄉', zipcode: '913', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '潮州鎮': { name: '潮州鎮', zipcode: '920', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '泰武鄉': { name: '泰武鄉', zipcode: '921', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
                '來義鄉': { name: '來義鄉', zipcode: '922', otherShippingFee: 130, largeShippingFee: 0, unknownLargeShippingFee: true },
                '萬巒鄉': { name: '萬巒鄉', zipcode: '923', otherShippingFee: 65, largeShippingFee: 0, unknownLargeShippingFee: true },
                '崁頂鄉': { name: '崁頂鄉', zipcode: '924', otherShippingFee: 40, largeShippingFee: 0, unknownLargeShippingFee: true },
                '新埤鄉': { name: '新埤鄉', zipcode: '925', otherShippingFee: 65, largeShippingFee: 0, unknownLargeShippingFee: true },
                '南州鄉': { name: '南州鄉', zipcode: '926', otherShippingFee: 40, largeShippingFee: 0, unknownLargeShippingFee: true },
                '林邊鄉': { name: '林邊鄉', zipcode: '927', otherShippingFee: 40, largeShippingFee: 0, unknownLargeShippingFee: true },
                '東港鎮': { name: '東港鎮', zipcode: '928', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '琉球鄉': { name: '琉球鄉', zipcode: '929', otherShippingFee: 90, largeShippingFee: 0, unknownLargeShippingFee: true },
                '佳冬鄉': { name: '佳冬鄉', zipcode: '931', otherShippingFee: 65, largeShippingFee: 0, unknownLargeShippingFee: true },
                '新園鄉': { name: '新園鄉', zipcode: '932', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '枋寮鄉': { name: '枋寮鄉', zipcode: '940', otherShippingFee: 65, largeShippingFee: 0, unknownLargeShippingFee: true },
                '枋山鄉': { name: '枋山鄉', zipcode: '941', otherShippingFee: 65, largeShippingFee: 0, unknownLargeShippingFee: true },
                '春日鄉': { name: '春日鄉', zipcode: '942', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
                '獅子鄉': { name: '獅子鄉', zipcode: '943', otherShippingFee: 130, largeShippingFee: 0, unknownLargeShippingFee: true },
                '車城鄉': { name: '車城鄉', zipcode: '944', otherShippingFee: 65, largeShippingFee: 0, unknownLargeShippingFee: true },
                '牡丹鄉': { name: '牡丹鄉', zipcode: '945', otherShippingFee: 130, largeShippingFee: 0, unknownLargeShippingFee: true },
                '恆春鎮': { name: '恆春鎮', zipcode: '946', otherShippingFee: 130, largeShippingFee: 8000 },
                '滿州鄉': { name: '滿州鄉', zipcode: '947', otherShippingFee: 130, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '臺東縣': {
                '臺東市': { name: '臺東市', zipcode: '950', otherShippingFee: 0, largeShippingFee: 8000 },
                '綠島鄉': { name: '綠島鄉', zipcode: '951', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '蘭嶼鄉': { name: '蘭嶼鄉', zipcode: '952', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '延平鄉': { name: '延平鄉', zipcode: '953', otherShippingFee: 90, largeShippingFee: 0, unknownLargeShippingFee: true },
                '卑南鄉': { name: '卑南鄉', zipcode: '954', otherShippingFee: 35, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鹿野鄉': { name: '鹿野鄉', zipcode: '955', otherShippingFee: 35, largeShippingFee: 0, unknownLargeShippingFee: true },
                '關山鎮': { name: '關山鎮', zipcode: '956', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '海端鄉': { name: '海端鄉', zipcode: '957', otherShippingFee: 850, largeShippingFee: 0, unknownLargeShippingFee: true },
                '池上鄉': { name: '池上鄉', zipcode: '958', otherShippingFee: 850, largeShippingFee: 0, unknownLargeShippingFee: true },
                '東河鄉': { name: '東河鄉', zipcode: '959', otherShippingFee: 195, largeShippingFee: 0, unknownLargeShippingFee: true },
                '成功鎮': { name: '成功鎮', zipcode: '961', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '長濱鄉': { name: '長濱鄉', zipcode: '962', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '太麻里鄉': { name: '太麻里鄉', zipcode: '963', otherShippingFee: 75, largeShippingFee: 0, unknownLargeShippingFee: true },
                '金峰鄉': { name: '金峰鄉', zipcode: '964', otherShippingFee: 75, largeShippingFee: 0, unknownLargeShippingFee: true },
                '大武鄉': { name: '大武鄉', zipcode: '965', otherShippingFee: 75, largeShippingFee: 0, unknownLargeShippingFee: true },
                '達仁鄉': { name: '達仁鄉', zipcode: '966', otherShippingFee: 85, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '花蓮縣': {
                '花蓮市': { name: '花蓮市', zipcode: '970', otherShippingFee: 0, largeShippingFee: 6000 },
                '新城鄉': { name: '新城鄉', zipcode: '971', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '秀林鄉': { name: '秀林鄉', zipcode: '972', otherShippingFee: 850, largeShippingFee: 0, unknownLargeShippingFee: true },
                '吉安鄉': { name: '吉安鄉', zipcode: '973', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '壽豐鄉': { name: '壽豐鄉', zipcode: '974', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '鳳林鎮': { name: '鳳林鎮', zipcode: '975', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '光復鄉': { name: '光復鄉', zipcode: '976', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '豐濱鄉': { name: '豐濱鄉', zipcode: '977', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '瑞穗鄉': { name: '瑞穗鄉', zipcode: '978', otherShippingFee: 110, largeShippingFee: 0, unknownLargeShippingFee: true },
                '萬榮鄉': { name: '萬榮鄉', zipcode: '979', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '玉里鎮': { name: '玉里鎮', zipcode: '981', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '卓溪鄉': { name: '卓溪鄉', zipcode: '982', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '富里鄉': { name: '富里鄉', zipcode: '983', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '金門縣': {
                '金沙鎮': { name: '金沙鎮', zipcode: '890', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
                '金湖鎮': { name: '金湖鎮', zipcode: '891', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
                '金寧鄉': { name: '金寧鄉', zipcode: '892', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
                '金城鎮': { name: '金城鎮', zipcode: '893', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
                '烈嶼鄉': { name: '烈嶼鄉', zipcode: '894', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
                '烏坵鄉': { name: '烏坵鄉', zipcode: '896', otherShippingFee: 215, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '連江縣': {
                '南竿鄉': { name: '南竿鄉', zipcode: '209', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '北竿鄉': { name: '北竿鄉', zipcode: '210', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '莒光鄉': { name: '莒光鄉', zipcode: '211', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
                '東引鄉': { name: '東引鄉', zipcode: '212', otherShippingFee: 0, largeShippingFee: 0, unknownLargeShippingFee: true },
            },
            '澎湖縣': {
                '馬公市': { name: '馬公市', zipcode: '880', otherShippingFee: 180, largeShippingFee: 0, unknownLargeShippingFee: true },
                '西嶼鄉': { name: '西嶼鄉', zipcode: '881', otherShippingFee: 270, largeShippingFee: 0, unknownLargeShippingFee: true },
                '望安鄉': { name: '望安鄉', zipcode: '882', otherShippingFee: 350, largeShippingFee: 0, unknownLargeShippingFee: true },
                '七美鄉': { name: '七美鄉', zipcode: '883', otherShippingFee: 350, largeShippingFee: 0, unknownLargeShippingFee: true },
                '白沙鄉': { name: '白沙鄉', zipcode: '884', otherShippingFee: 250, largeShippingFee: 0, unknownLargeShippingFee: true },
                '湖西鄉': { name: '湖西鄉', zipcode: '885', otherShippingFee: 250, largeShippingFee: 0, unknownLargeShippingFee: true },
            }
        };

        var removeAreas = {
            '南竿鄉': '209',
            '北竿鄉': '210',
            '莒光鄉': '211',
            '東引鄉': '212',
            '馬公市': '880',
            '西嶼鄉': '881',
            '望安鄉': '882',
            '七美鄉': '883',
            '白沙鄉': '884',
            '湖西鄉': '885',
            '金沙鎮': '890',
            '金湖鎮': '891',
            '金寧鄉': '892',
            '金城鎮': '893',
            '烈嶼鄉': '894',
            '烏坵鄉': '896',
            '琉球鄉': '929',
            '綠島鄉': '951',
            '蘭嶼鄉': '952',
        }

        // ------------------------------
        // 產生台灣地址seletor相關資訊
        // ------------------------------
        var initTWZipCode = function(isOnlyTaipei) {

            $scope.cityList.push({
                name: '縣市',
                distList: [{
                    name: '鄉鎮市區',
                    zipcode: '',
                }],
            })

            for(var city in zipcodedata){

                if(isOnlyTaipei && city != '臺北市' && city != '新北市') {
                    continue;
                }

                var citydata = zipcodedata[city];
                var distList = [];

                distList.push({
                    name: '鄉鎮市區',
                    zipcode: '',
                });

                for(var dist in citydata) {
                    var distdata = citydata[dist];

                    distList.push({
                        name: dist,
                        zipcode: distdata.zipcode,
                    });
                }

                $scope.cityList.push({
                    name: city,
                    distList: distList,
                })
            }

            $scope.form.selectCity = $scope.cityList[0];
            $scope.form.selectDist = $scope.cityList[0].distList[0];
        }

        // ------------------------------
        // 產生配送至 台灣地址seletor相關資訊（含運費）
        // ------------------------------
        var initTWZipCodeWithoutRemoteAreas = function(isOnlyTaipei) {

            $scope.cityList.push({
                name: '縣市',
                distList: [{
                    name: '鄉鎮市區',
                    zipcode: '',
                }],
            })

            for(var city in zipcodedata){
                
                if(isOnlyTaipei && city != '臺北市' && city != '新北市') {
                    continue;
                }

                var citydata = zipcodedata[city];
                var distList = [];

                distList.push({
                    name: '鄉鎮市區',
                    zipcode: '',
                });

                for(var dist in citydata) {
                    // 不配送
                    if(removeAreas[dist] !== undefined) {
                        continue;
                    }

                    var distdata = citydata[dist];
                    var otherShippingFee = getBoundShippingFee(distdata.otherShippingFee);
                    var largeShippingFee = distdata.largeShippingFee;
                    var unknownLargeShippingFee = distdata.unknownLargeShippingFee;

                    distList.push({
                        name: dist,
                        zipcode: distdata.zipcode,
                        otherShippingFee: otherShippingFee,
                        largeShippingFee: largeShippingFee,
                        unknownLargeShippingFee: unknownLargeShippingFee,
                    });
                }

                if(distList.length > 1) {
                    $scope.cityList.push({
                        name: city,
                        distList: distList,
                    })
                }
            }

            $scope.form.selectCity = $scope.cityList[0];
            $scope.form.selectDist = $scope.cityList[0].distList[0];
        }

        // ------------------------------
        // getBoundShippingFee
        // ------------------------------
        var getBoundShippingFee = function(otherShippingFee) {

            if(otherShippingFee <= 0) {
                return 0;
            }

            var d = parseInt((otherShippingFee - 1) / 100);
            var result = parseInt((d + 1) * 100);

            return result;
        }

        // ------------------------------
        // changeCity
        // ------------------------------
        var changeCity = function() {

            $scope.form.selectDist = $scope.form.selectCity.distList[0];
            $scope.city = $scope.form.selectCity.name;
            $scope.dist = $scope.form.selectDist.name;
            $scope.zipcode = $scope.form.selectDist.zipcode;
            $scope.otherShippingFee = $scope.form.selectDist.otherShippingFee || 0 ;
            $scope.largeShippingFee = $scope.form.selectDist.largeShippingFee || 0 ;
        }

        // ------------------------------
        // changeDist
        // ------------------------------
        var changeDist = function() {

            $scope.dist = $scope.form.selectDist.name;
            $scope.zipcode = $scope.form.selectDist.zipcode;
            $scope.otherShippingFee = $scope.form.selectDist.otherShippingFee || 0 ;
            $scope.largeShippingFee = $scope.form.selectDist.largeShippingFee || 0 ;

            updateAddress();
        }

        // ------------------------------
        // findCityDistByZipCode
        // ------------------------------
        var findCityDistByZipCode = function(zipcode) {

            if(zipcode) {
                for(var i = 0; i < $scope.cityList.length; i++) {
                    var city = $scope.cityList[i];
                    for(var j = 0; j < city.distList.length; j++) {
                        var dist = city.distList[j];

                        if(zipcode == dist.zipcode) {
                            $scope.form.selectCity = city;
                            $scope.form.selectDist = dist;
                            return true;
                        }
                    }
                }
            }

            return false;
        }

        // ------------------------------
        // findCityDistByFullAddress
        // ------------------------------
        var findCityDistByFullAddress = function(address) {

            if(address) {
                for(var i = 0; i < $scope.cityList.length; i++) {
                    var city = $scope.cityList[i];

                    if(address.indexOf(city.name) == 0) {
                        for(var j = 0; j < city.distList.length; j++) {
                            var dist = city.distList[j];

                            if(address.indexOf(dist.name) == city.name.length) {
                                $scope.form.selectCity = city;
                                $scope.form.selectDist = dist;
                                return true;
                            }
                        }
                    }
                }
            }

            return false;
        }

        // ------------------------------
        // findAddress
        // ------------------------------
        var findAddress = function() {

            // var result = findCityDistByZipCode($scope.zipcode);

            // if(!result) {
            //     result = findCityDistByFullAddress($scope.address);
            // }

            var result = findCityDistByFullAddress($scope.address);

            if(result) {
                $scope.city = $scope.form.selectCity.name;
                $scope.dist = $scope.form.selectDist.name;
                $scope.zipcode = $scope.form.selectDist.zipcode;

                $scope.shippingFeeInfo = {
                    otherShippingFee: $scope.form.selectDist.otherShippingFee || 0,
                    largeShippingFee: $scope.form.selectDist.largeShippingFee || 0,
                    unknownLargeShippingFee: $scope.form.selectDist.unknownLargeShippingFee,
                };

                // $scope.otherShippingFee = $scope.form.selectDist.otherShippingFee || 0 ;
                // $scope.largeShippingFee = $scope.form.selectDist.largeShippingFee || 0 ;
                $scope.newAddress = $scope.address.substr($scope.city.length + $scope.dist.length);
                $scope.form.newAddress = $scope.newAddress || '';
                updateAddress();
            } else {
                $scope.city = '';
                $scope.dist = '';
                $scope.zipcode = '';

                $scope.shippingFeeInfo = {
                    otherShippingFee: 0,
                    largeShippingFee: 0,
                    unknownLargeShippingFee: false,
                }

                $scope.newAddress = '';
                $scope.form.newAddress = '';
                $scope.form.selectCity = $scope.cityList[0];
                $scope.form.selectDist = $scope.cityList[0].distList[0];
                
                updateAddress();
            }
        }

        // ------------------------------
        // changeAddress
        // ------------------------------
        var changeAddress = function(address) {

            $scope.newAddress = address;
            $scope.addressChange && $scope.addressChange(address);
            updateAddress();
        }

        // ------------------------------
        // updateAddress
        // ------------------------------
        var updateAddress = function() {

            if($scope.newAddress === undefined) {
                $scope.newAddress = '';
            }
            
            $scope.address = $scope.city + $scope.dist + $scope.newAddress;
        }

        // ------------------------------
        // init
        // ------------------------------
        var init = function() {

            var isWithoutRemoteAreas = $attrs.isWithoutRemoteAreas == 'true';
            var isOnlyTaipei = $attrs.isOnlyTaipei == 'true';

            if(isWithoutRemoteAreas) {
                initTWZipCodeWithoutRemoteAreas(isOnlyTaipei);
            } else {
                initTWZipCode(isOnlyTaipei);    
            }

            findAddress();
        }

        //==========================
        //  Events
        //==========================
        $scope.$watch('address', function(newValue, oldValue) {
            if(newValue){
                findAddress();
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.form = {
            selectCity: undefined,
            selectDist: undefined,
            newAddress: '',
        };

        $scope.cityList = []; 
        $scope.cityListWithoutRA = [];

        //==========================
        //  Methods
        //==========================
        $scope.changeCity = changeCity;
        $scope.changeDist = changeDist;
        $scope.changeAddress = changeAddress;

        init();
    }];

    _dir.restrict = 'E';
    _dir.controller = controller;
    _dir.replace = true;
    _dir.templateUrl = "mobile/partials/directives/tw_zip_code.html";
    _dir.scope = {
        city: '=',
        dist: '=',
        zipcode: '=',
        address: '=',
        newAddress: '=',
        isError: '=',
        addressChange: '=',
        otherShippingFee: '=',
        largeShippingFee: '=',
        shippingFeeInfo: '=',
    };

    return _dir;
}]);
